export const SURVEY_TYPE = {
    SURVEYMONKEY: 3,
    CUSTOMLINK: 4,
    STANDARD: 5,
};

export const SURVEY_FEEDBACK = {
    LIKEUP: 1,
    LIKEDOWN: -1,
};

export const SURVEY_COMMENT_MAX_LENGTH = 250;
